
import { MathBase } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { PokerTextHelper } from "./PokerTextHelper";

import { Back, Power2, Power3, Power4, Sine, TimelineLite, TweenLite } from "gsap";
import { TweenMaxGroup } from "./TweenMaxGroup";
import { NumberStringHelper } from "../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import ColorMatrixFilter = createjs.ColorMatrixFilter;
import Point = createjs.Point;
import Event = createjs.Event;

export class AniTableHelper {
    private playerCardAnimations: any[];
    private mtxFilter: ColorMatrixFilter;

    constructor() {
    }

    public addPlayerCardAnimation(playerCardholder: MovieClip, animation: MovieClip): void {
        if (playerCardholder == null || animation == null)
            return;

        if (this.playerCardAnimations == null)
            this.playerCardAnimations = new Array();
        this.playerCardAnimations.push(animation);

        animation.gotoAndPlay(1);
        playerCardholder.mc_holder.addChild(animation);
        animation.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onAnimating));
    }

    private onAnimating(event: Event): void {
        if (event.target) {
            if (event.target.currentFrame == event.target.totalFrames - 1) {
                this.onPlayerCardAnimationEnd(event.target);
            }
        }
    }

    private onPlayerCardAnimationEnd(targetAnimation: MovieClip): void {
        targetAnimation.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.onAnimating));
        var animation: MovieClip;
        while (this.playerCardAnimations.length > 0) {
            animation = this.playerCardAnimations[0];
            animation.stop();
            this.onRemoveChild(animation);
            this.playerCardAnimations.splice(0, 1);
        }
    }

    private dealerMC: MovieClip;
    public posDealer(seatNo: number, showDealer: boolean, dealerMC: MovieClip, dealerPosAry: any[]): void {
        if (seatNo >= 0 && dealerMC) {
            this.dealerMC = dealerMC;
            //
            dealerMC.visible = showDealer;
            var startX: number = dealerMC.x;
            var startY: number = dealerMC.y;
            var zielX: number = dealerPosAry[seatNo][0];
            var zielY: number = dealerPosAry[seatNo][1];
            var tween: TweenMaxGroup;
            //
            if (startX == 0 && startY == 0) {
                dealerMC.x = zielX;
                dealerMC.y = zielY;
            }
            else {
                tween = new TweenMaxGroup();
                tween.to(dealerMC, .9, { x: zielX, y: zielY, onComplete: this.bindFunction(this.posDealerComplete), onCompleteParams: [tween] });
                tween.play();
            }

            if (this.tutorialController.isActive) {
                {
                    switch (this.tutorialController.tutorialState) {
                        case "tut_step6_dealerButton":
                            this.posDealerSpotlight();
                            if (tween) {
                                var timeline: TimelineLite = new TimelineLite({ onUpdate: this.bindFunction(this.posDealerSpotlight) });
                                timeline.add(TweenLite.to(dealerMC, .9, { x: zielX, y: zielY }));
                            }
                            break;
                    }
                }
            }

        }
    }

    private posDealerSpotlight(current: any = null): void {
        switch (this.tutorialController.tutorialState) {
            case "tut_step6_dealerButton":
                this.layoutManager.tutPanel.showSpotlight(this.dealerMC);
                break;
        }
    }

    // Slide chips from player to the pot
    public animationChips2PotOnePlayer(betContainer: MovieClip, potContainer: MovieClip): void {
        if (betContainer.mc_holder.numChildren <= 0)
            return;
        betContainer.txt_amount.text = "";

        var potPosition: Point = potContainer.localToGlobal(new Point(0, 0));
        var potToBetPosition: Point = betContainer.mc_holder.globalToLocal(potPosition);
        var tween: TweenMaxGroup = new TweenMaxGroup();
        for (var i: number = 0; i < betContainer.mc_holder.numChildren; i++) {
            tween.to(betContainer.mc_holder.getChildAt(i), 1, { x: (potToBetPosition.x + potContainer.mc_holder.x), y: (potToBetPosition.y + potContainer.mc_holder.y), ease: Power2.easeOut, onComplete: this.bindFunction(this.onCompletePotAnim), onCompleteParams: [betContainer.mc_holder.getChildAt(i), tween] });
            tween.play();
        }
    }

    private onCompletePotAnim(bet: MovieClip, tweenGroup: TweenMaxGroup): void {
        this.disposeTweenGroup(tweenGroup);
        var tween: TweenMaxGroup = new TweenMaxGroup();
        tween.to(bet, 0.5, { alpha: 0, onComplete: this.bindFunction(this.onRemoveChild), onCompleteParams: [bet, tween] });
        tween.play();
    }

    public animationFoldOnePlayer(playerContainer: MovieClip, communityCardContainer: MovieClip): void {
        var foldCards: MovieClip = new Library.PokerTable.FoldCard();
        var foldCardsTwo: MovieClip = new Library.PokerTable.FoldCard();
        playerContainer.addChild(foldCards);
        playerContainer.addChild(foldCardsTwo);
        var startPosition: Point = communityCardContainer.localToGlobal(new Point(0, 0));
        var foldCardPosition: Point = playerContainer.globalToLocal(startPosition);

        var tweenOne: TweenMaxGroup = new TweenMaxGroup();
        var tweenTwo: TweenMaxGroup = new TweenMaxGroup();
        tweenOne.to(foldCards, 1.0, { x: (foldCardPosition.x + 50), y: foldCardPosition.y, rotation: 180, ease: Power2.easeOut, onComplete: this.bindFunction(this.onCompletePotAnim), onCompleteParams: [foldCards, tweenOne] });
        tweenOne.play();
        tweenTwo.to(foldCardsTwo, 1.4, { x: (foldCardPosition.x + 75), y: foldCardPosition.y, rotation: 135, ease: Power2.easeOut, onComplete: this.bindFunction(this.onCompletePotAnim), onCompleteParams: [foldCardsTwo, tweenTwo] });
        tweenTwo.play();
    }

    public animationcommunityCard(targetY: number, targetX: number, card: Container, delay: number): void {
        var tween: TweenMaxGroup = new TweenMaxGroup();
        tween.to(card, 2.0, { x: targetX, y: targetY, delay, onComplete: this.bindFunction(this.disposeTweenGroup), onCompleteParams: [tween] });
        tween.play();
    }

    public animationFromToPlayer(fromPlayer: MovieClip, toPlayer: MovieClip, item: MovieClip, destroy: boolean = false): void {
        var startPosition: Point = toPlayer.localToGlobal(new Point(0, 0));
        var targetPosition: Point = fromPlayer.globalToLocal(startPosition);
        var tween: TweenMaxGroup = new TweenMaxGroup();

        if (destroy) {
            tween.fromTo(item, 3.0, { x: -targetPosition.x, y: -targetPosition.y }, {
                x: 0,
                y: 0,
                ease: Power2.easeOut,
                onComplete: this.bindFunction(this.onRemoveChild),
                onCompleteParams: [item, tween]
            });
            tween.play();
        }
        else {
            if (targetPosition.x != 0 && targetPosition.y != 0) {
                tween.fromTo(item, 3.0, { x: -targetPosition.x, y: -targetPosition.y }, {
                    x: item.x,
                    y: item.y,
                    onComplete: this.bindFunction(this.disposeTweenGroup),
                    onCompleteParams: [tween]
                });
                tween.play();
            }
        }
    }

    private static GIFT_CHIPS_START_POSITION_OFFSET_Y: number = 22;
    /** Configure x position of the chips mc to center the element. **/
    private static GIFT_CHIPS_MC_OFFSET_X: number = 18;
    /** Configure y position of the chips mc to center the element.**/
    private static GIFT_CHIPS_MC_OFFSET_Y: number = 25;
    private static AMOUNT_FADEIN_DURATION: number = 1.6;
    private static AMOUNT_SHOW_DURATION: number = 0.8;
    /** Max duration for the chips' slide (for the largest distance) **/
    private static SLIDE_DURATION_MAX: number = 2.0;
    /** Min duration for the chips' slide (for the shortest distance) **/
    private static SLIDE_DURATION_MIN: number = 0.7;
    private static ASSUMED_MAX_DISTANCE: number = 655;

    public doGiveChipsAnimation(fromPlayer: MovieClip, toPlayer: MovieClip, giftChipsMc: Library.PokerInterface.GiftChips, chipAmount: number): void {
        var startPosition: Point = toPlayer.localToGlobal(new Point(0, 0));
        var targetPosition: Point = fromPlayer.globalToLocal(startPosition);

        // set start position of gift chips mc
        giftChipsMc.x -= targetPosition.x + AniTableHelper.GIFT_CHIPS_MC_OFFSET_X;
        giftChipsMc.y -= targetPosition.y + AniTableHelper.GIFT_CHIPS_MC_OFFSET_Y;
        // set target position
        targetPosition.x = -AniTableHelper.GIFT_CHIPS_MC_OFFSET_X;
        targetPosition.y = -AniTableHelper.GIFT_CHIPS_MC_OFFSET_Y - 20;

        // init gift chips mc
        giftChipsMc.mc_amount.txt_amount.text = NumberStringHelper.groupString(chipAmount, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        giftChipsMc.icon.scaleX = giftChipsMc.icon.scaleY = 0.2;

        // get distance between the seats
        var distance: number = MathBase.distance(fromPlayer.x, toPlayer.x, fromPlayer.y, toPlayer.y);
        var p: number = distance / AniTableHelper.ASSUMED_MAX_DISTANCE;

        // calculate the slide ani duration according the to distance between the two seats (wider distances will take longer)
        var slideDuration: number = AniTableHelper.SLIDE_DURATION_MAX * p;
        // take at least the mininum slide duration
        slideDuration = (slideDuration < AniTableHelper.SLIDE_DURATION_MIN) ? AniTableHelper.SLIDE_DURATION_MIN : slideDuration;

        // scale icon to full size
        TweenLite.to(giftChipsMc.icon, 0.4, { scaleX: 1, scaleY: 1, ease: Back.easeOut, easeParams: [0.3] });

        // slide gift chips
        var tween: TweenMaxGroup = new TweenMaxGroup();
        tween.to(giftChipsMc, slideDuration, { x: targetPosition.x, y: targetPosition.y, ease: Sine.easeInOut, delay: 0.4 });

        // show amount
        tween.to(giftChipsMc.mc_amount, AniTableHelper.AMOUNT_FADEIN_DURATION, { alpha: 1, y: "-30", scaleX: 1.3, scaleY: 1.3, ease: Power3.easeInOut, delay: slideDuration + 0.1 });

        // scale icon small
        tween.to(giftChipsMc.icon, .5, { scaleX: 0, scaleY: 0, ease: Back.easeOut, delay: slideDuration + .2 });

        // slide amount up
        tween.to(giftChipsMc.mc_amount, 0.3, { alpha: 0, y: "-70", scaleX: 0.7, scaleY: 0.7, ease: Power4.easeOut, delay: slideDuration + AniTableHelper.AMOUNT_FADEIN_DURATION + AniTableHelper.AMOUNT_SHOW_DURATION, onComplete: this.bindFunction(this.onRemoveChild), onCompleteParams: [giftChipsMc, tween] });

        tween.play();
    }

    private onRemoveChild(item: MovieClip, tween: TweenMaxGroup = null): void {
        if (tween)
            this.disposeTweenGroup(tween);

        if (item && item.parent)
            item.parent.removeChild(item);
    }

    public animationToOnewinner(potContainer: MovieClip, winnerContainer: MovieClip, chips: Library.PokerTable.Chips, winnerAmount: number, delay: number = 0): void {
        var tween: TweenMaxGroup = new TweenMaxGroup();
        var startPosition: Point = winnerContainer.localToGlobal(new Point(0, 0));
        var targetPosition: Point = potContainer.globalToLocal(startPosition);
        tween.fromTo(chips, 1.0, { x: 0, y: 0 }, { x: targetPosition.x, y: targetPosition.y, ease: Power2.easeOut, delay: delay, onComplete: this.bindFunction(this.onCompleteChipEarnAnim), onCompleteParams: [chips, tween, winnerContainer, winnerAmount] });
        tween.play();
    }

    private onCompleteChipEarnAnim(chips: MovieClip, tweenGroup: TweenMaxGroup, winnerContainer: MovieClip, winnerAmount: number): void {
        var chipsearn: Library.PokerTable.ChipsEarn = new Library.PokerTable.ChipsEarn();
        chipsearn.txt_amount.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        chipsearn.txt_amount.text = PokerTextHelper.getShortGroupNumberString(winnerAmount);
        winnerContainer.addChild(chipsearn);

        var timeline: TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(chipsearn, 1, { y: 45, ease: Sine.easeOut, onComplete: this.bindFunction(this.onRemoveChild), onCompleteParams: [chipsearn] }));
        timeline.addPause("+=1");
        timeline.play();
        this.disposeTweenGroup(tweenGroup);
        var tween: TweenMaxGroup = new TweenMaxGroup();
        tween.to(chips, 0.5, { alpha: 0, onComplete: this.bindFunction(this.onRemoveChild), onCompleteParams: [chips, tween] });
        tween.play();
    }

    public disposeTweenGroup(tween: TweenMaxGroup): void {
        tween.destroy();
        tween = null;
    }

    private posDealerComplete(tween: TweenMaxGroup): void {
        this.posDealerSpotlight();
        this.dealerMC = null;
        //
        this.disposeTweenGroup(tween);
    }

    public hideDealer(dealer: MovieClip): void {
        dealer.visible = false;
    }

    /*		public function moveDealerHome(dealer:MovieClip,dealerPosAry:Array):void {
                var moveObj:MovieClip = dealer;
                var zielX:Number=dealerPosAry[dealerSeatsNo].x;
                var zielY:Number=dealerPosAry[dealerSeatsNo].y;
                moveObj.x=zielX;
                moveObj.y=zielY;
            }*/

    // 1234 -> 1*1000er Chip, 2*100erChip, ..
    public setChipsWert2Chips(c: Library.PokerTable.Chips, chipsWert: number): void {
        /*
        Weiß                   1
        Gelb                   5
        Rot                   10
        Blau                  50
        Grau                 100
        Grün                 500
        Orange             1.000
        Schwarz            5.000
        Pink              10.000
        Lila              50.000
        Burgund          100.000
        Hellblau         500.000
        Braun          1.000.000
        Blau-Gelb      5.000.000
        Grün-Rot      25.000.000
        Schwarz-Blau 100.000.000
        Gelb-Orange  500.000.000
        */
        var chipsWertAry: any[] = [1, 5, 10, 50, 100, 500, 1e3, 5e3, 1e4, 5e4, 1e5, 5e5, 1e6, 5e6, 25e6, 1e8, 5e8];

        // vertikal differenz from chip to chip
        var chipH: number = 10;
        // random horizontal differenz
        var rndX: number = 30;

        var chips: Library.PokerTable.Chips;
        var haufenYAry: any[];
        var haufenXAry: any[];
        var haufenZAry: any[];
        var chipsAry: any[] = [];
        var anz: number = 0;
        var menge: number = 0;
        var chipsMenge: number = 0;
        var i: number = 0;
        var j: number = 0;
        var h: number = 0;
        var anzH: number = 0;
        var n: number = 0;
        //
        while (c.numChildren > 0)
            c.removeChildAt(0);

        if (chipsWert > 0) {
            // calc number and art of chips
            chipsMenge = 0;
            anz = int(chipsWertAry.length);
            for (i = anz - 1; i >= 0; i--) {
                menge = int(int(chipsWert / chipsWertAry[i]));
                if (menge >= 1) {
                    chipsAry.push({ pos: i + 2, menge: menge });
                    chipsWert -= chipsWertAry[i] * menge;
                    chipsMenge += menge;
                }
            }
            // set chips to position from 1 to 5 groups
            haufenYAry = [0, -30, -15, 0, -5];
            haufenXAry = [0, -70, 70, -130, 130];
            haufenZAry = [0, 0, 0, 0, 0];
            for (i = 0; i < haufenYAry.length; i++) {
                haufenYAry[i] += rndX / 2 - Math.random() * rndX / 4;
                haufenXAry[i] += rndX / 4 - Math.random() * rndX / 8 - 35; // chipsbreite=70
            }
            anzH = int(Math.min(5, Math.max(1, int(chipsMenge / 3))));
            n = 0;
            for (i = 0; i < chipsAry.length; i++) {
                anz = int(chipsAry[i].menge);
                for (j = 0; j < anz; j++) {
                    h = int(n % anzH);
                    chips = new Library.PokerTable.Chips();
                    chips.y -= (haufenZAry[h]++) * chipH + haufenYAry[h];
                    //chips.x=rndX-Math.random()*rndX/2+haufenXAry[h];
                    chips.x = rndX + haufenXAry[h];
                    chips.gotoAndStop(chipsAry[i].pos);
                    c.addChild(chips);
                    n++;
                    if (anzH > 1 &&
                        ((n == int(chipsMenge * .65)) || (n == int(chipsMenge * .7)) || (n == int(chipsMenge * .84)) || (n == int(chipsMenge * .92))))
                        anzH--;
                }
            }
        }
    }//setChips..

    public grayscale(mc: MovieClip): void {
        var b: number = 1 / 3;
        var c: number = 1 - (b * 2);
        var mtx: any[] =
            [c, b, b, 0, 0,
                b, c, b, 0, 0,
                b, b, c, 0, 0,
                0, 0, 0, 1, 0];
        if (this.mtxFilter == null)
            this.mtxFilter = new ColorMatrixFilter(mtx);
        mc.filters = [this.mtxFilter];
    }
    public unGrayscale(mc: MovieClip): void {
        mc.filters = [];
    }

    private get tutorialController(): Poker2TutorialController {
        return Poker2TutorialController.getInstance();
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}

import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2LayoutManager } from "../Poker2LayoutManager";
